import { addMonths } from 'date-fns'

/**
 * Store related to any metadata about the offer request,
 * everything that is not already stored in the garden properties
 */
export const useRequestMetaStore = defineStore('requestMeta', () => {
  const options = useOptions()

  const uuid = ref<string | undefined>(options.meta.uuid ?? undefined)
  const publicUuid = ref<string | undefined>(options.meta.publicUuid ?? undefined)
  const permalink = ref<string | undefined>(options.meta.permalink ?? undefined)
  const publicPermalink = ref<string | undefined>(options.meta.publicPermalink ?? undefined)
  const finalized = ref(options.meta.finalized ?? false)
  const finalizedDate = ref<Date | undefined>(
    options.meta.finalizedDatetime ? new Date(options.meta.finalizedDatetime) : undefined,
  )
  const paid = ref(options.meta.paid ?? false)
  // Present (and trustworthy - already verified server-side) whenever this
  // announcement was started via a Bestatter link, whether freshly from the
  // URL or read back from the persisted post on resume.
  const bestatterId = ref<string | undefined>(options.meta.bestatterId ?? undefined)
  // Raw signed token, only present for a brand-new (not yet created) Bestatter
  // draft - forwarded once to /store so the backend can verify and persist it.
  const bestatterToken = ref<string | undefined>(options.meta.bestatterToken ?? undefined)

  return {
    uuid,
    publicUuid,
    permalink,
    publicPermalink,
    finalized,
    finalizedDate,
    paid,
    bestatterId,
    bestatterToken,
  }
})
